import { Route, Routes } from 'react-router-dom';

import { OfferDesignForm } from './pages/Form/OfferDesignForm';
import OfferDesignTable from './pages/OfferDesignTable/OfferDesignTable';
import SelectOfferType from './pages/SelectOfferType/SelectOfferType';

const OfferDesignView = () => {
  return (
    <Routes>
      <Route path="/" element={<OfferDesignTable />} />
      <Route path="/select-type" element={<SelectOfferType />} />
      <Route path="/form" element={<OfferDesignForm />} />
      <Route path="/form/:offerUIId" element={<OfferDesignForm />} />
      <Route path="/dup/:offerUIId" element={<OfferDesignForm />} />
    </Routes>
  );
};

export default OfferDesignView;
